<template>
  <div id="sweepstakes" v-if="isAvailable">
    <div class="head">
      <span class="icon">
        <img
          src="@/assets/img/icon-sprite-union-logomark.png"
          class="sprite"
          alt="UNION Biztosító"
        />
      </span>
      <h1 class="label">Jelentkezés nyereményjátékra</h1>
    </div>
    <div class="ad">
      <!-- common image in all app -->
      <img
        src="@/assets/img/utas-head-2025-nyar.png"
        class="ad-image"
        alt="Vár a nyár!"
      />
      <!-- img from config.js -->
      <!-- <img
        v-if="getImgUrl()"
        v-bind:src="getImgUrl()"
        class="ad-image"
        v-bind:alt="getImgAlt()"
      /> -->
      <h2 class="ad-title">{{ sweepstake.title }}</h2>
      <p class="ad-description" v-html="getDescription()"></p>
    </div>
    <FormSweepstakes></FormSweepstakes>
    <Loader></Loader>
    <div class="legal">
      <img
        src="@/assets/img/logo-union.png"
        class="logo"
        alt="UNION Biztosító Zrt."
      />
      Copyright © 2025 UNION Biztosító Zrt.
    </div>
  </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
//import InputError from './components/InputError.vue';
//import FormSweepstakes from './components/FormSweepstakes.vue'
//import Config from "@/config.js";

export default {
  name: "App",
  components: {
    //FormSweepstakes
  },
  created: function() {
    // this.$log.debug(this.swName);
    this.$log.debug(this.now, this.isAvailable);
    this.$log.debug(this.$kRevoUrl().getSweepstake());
  },
  data: function() {
    return {
      now: new Date().getTime(),
      sweepstake: this.$kRevoUrl().getSweepstake()
    };
  },
  computed: {
    isAvailable: function() {
      // this.$log.debug(this.sweepstake.startdate, this.sweepstake.enddate);
      // return (
      //   this.now >= this.sweepstake.startdate &&
      //   this.now <= this.sweepstake.enddate
      // );
      // this.$log.debug(
      //   this.$kRevoUrl().getSweepstake().startdate,
      //   this.$kRevoUrl().getSweepstake().enddate
      // );
      return (
        this.now >= this.$kRevoUrl().getSweepstake().startdate &&
        this.now <= this.$kRevoUrl().getSweepstake().enddate
      );
    }
  },
  methods: {
    /*getSweepstake: function(){
      return Config.swepstakes[this.swName];
    },
    isSweepstake: function(){
      return typeof this.getSweepstake()==='object' && this.getSweepstake()!==undefined;
    }*/
    getDescription: function() {
      return this.$kRevoUrl().getSweepstake().description;
    }
    // getImgUrl: function() {
    //   return this.$kRevoUrl().getSweepstake().imgurl;
    // },
    // getImgAlt: function() {
    //   return this.$kRevoUrl().getSweepstake().imgalt;
    // }
  }
};
</script>

<style lang="scss">
//@import "@/scss/_variables.scss";  //imported globally
@import "@/scss/_fonts.scss";
@import "@/scss/_resets.scss";

#sweepstakes {
  font-size: 16px;
  position: relative;
  display: block;
  box-sizing: border-box;
  max-width: 26em;
  margin: 0px auto 0px auto;
  padding: 2em;
  border: 1px solid $colorGray;

  border-radius: 3px;
  box-shadow: 0px 0.25em 0.25em $colorGray;
  background-color: $colorWhite;

  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $colorGrayDark;

  .head {
    position: relative;
    display: block;
    box-sizing: border-box;
    font-size: 1em;
    //width: 100%;
    min-height: 3em;
    margin: -2em -2em 2em -2em;
    padding: 0px 1em 0px 5em;
    background-color: $colorRed;

    .icon {
      position: absolute;
      display: block;
      box-sizing: border-box;
      top: 0.75em;
      left: 1.65em;
      width: 2.5em;
      height: 2.5em;
      overflow: hidden;

      .sprite {
        position: absolute;
        display: block;
        box-sizing: border-box;
        top: -100%;
        left: 0px;
        width: 100%;
        height: auto;
      }
    }

    .label {
      position: relative;
      display: block;
      box-sizing: border-box;
      font-size: 1.25em;
      line-height: 110%;
      margin: 0px;
      padding: 0.5em 3em 0.5em 0px;
      color: $colorWhite;
      font-family: $font-family-normal;
      font-weight: normal;
    }
  }

  .ad {
    position: relative;
    display: block;
    box-sizing: border-box;
    font-size: 1em;
    min-height: 3em;
    margin: 0em -2em 2em -2em;
    padding: 0px;

    .ad-image {
      position: relative;
      display: block;
      box-sizing: border-box;
      width: 100%;
      height: auto;
      margin-top: -2em; //reset space between header and image element
    }

    .ad-title {
      position: relative;
      display: block;
      box-sizing: border-box;
      width: 100%;
      background-color: $colorWhite;
      font-size: 1.5em;
      margin: 0em 0px 0px 0px;
      padding: 0.5em 1.25em 0px 1.25em;
      font-weight: normal;
      font-family: $font-family-normal;
      color: $colorRed;
      //
      //override to hide this text
      font-size: 1px;
      color: $colorWhite;

      &::after {
        content: "Regisztráció";
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        box-sizing: border-box;
        width: 100%;
        height: 20px;
        background-color: $colorWhite;
        font-size: 24px; //1.5em;
        margin: 10px 0px 0px 0px;
        padding: 0.5em 1.25em 0px 1.25em;
        font-weight: normal;
        font-family: $font-family-normal;
        color: $colorRed;
      }
    }

    .ad-description {
      position: relative;
      display: block;
      box-sizing: border-box;
      width: 100%;
      background-color: $colorWhite;
      font-size: 0.8em;
      line-height: 135%;
      margin: 0px 0px 0px 0px;
      padding: 0.5em 2.5em 0px 2.5em;
      font-weight: normal;
      font-family: $font-family-normal;
      color: $colorGrayDark;
      //
      margin-top: 42px;

      b {
        font-weight: 600;
      }

      a {
        text-decoration: underline;
        color: $colorGrayDark;
      }
    }
  }

  .legal {
    position: relative;
    display: block;
    box-sizing: border-box;
    font-size: 0.625em;
    margin: 3.25em -3.25em -3.25em -3.25em;
    padding: 1em 3.25em 1em 3.25em;
    color: $colorGrayLight;
    background-color: $colorGrayDark;
    text-align: center;

    .logo {
      position: relative;
      display: block;
      box-sizing: border-box;
      width: 70%;
      height: auto;
      margin: 0px auto 0px auto;
    }
  }
}
</style>
